// This file is to be used for configuration of a specific customer's version of the web app

export default {
  companyInfo: {
    name: "Stone Age Landscapes",
    nameAbbreviated: "S.A.L.",
    phone: "763-954-1569",
    email: "tony@stoneagelandscapes.com",
    address: {
      street: "14739 95th Ave. N.",
      city: "Maple Grove",
      state: "MN",
      zip: "55369",
    },
  },
  companyLogo: process.env.BASE_URL + "photos/logo-sal.svg",
  companySocialMedia: {
    facebook: "https://www.facebook.com/profile.php?id=100054604143446",
    instagram: "https://www.instagram.com/stoneagelandscapes",
    pinterest: null,
    twitter: null,
    linkedIn: null,
  },
  moduleActivation: {
    mainSite: true,
    billing: false,
    scheduling: false,
    contactUs: false,
    referalProgram: false,
    gallery: true,
  },
};
